import dayjs from "dayjs";
import { logger } from "../../../../utilities/logger";
import { SharePointInputTypes } from "../../config/sharepointConstants";
import { SharePointInputData } from "../../interfaces/props/SharePointInputData";

export class DatasourceValidationHelper {
    static validateAndTransformDatasourceValue(input: SharePointInputData, value: any): any {
        try {
            const inputType = input.xml?.Type?.toLowerCase();
            if (inputType == SharePointInputTypes.text.toLowerCase() || inputType == SharePointInputTypes.note.toLowerCase()) {
                return value;
            }

            if (inputType == SharePointInputTypes.choice.toLowerCase() || inputType == SharePointInputTypes.multiChoice.toLowerCase()) {
                if (Array.isArray(input.choices)) {
                    const choiceValue = input.choices.find(choice => choice.toLowerCase().trim() === value.toLowerCase().trim());
                    if (choiceValue) return choiceValue;
                }
            } else if (inputType == SharePointInputTypes.number.toLowerCase() || inputType == SharePointInputTypes.currency.toLowerCase()) {
                let numberValue: number = Number(value);
                if (numberValue) {
                    if (input.xml?.Min && numberValue < input.xml.Min) {
                        return null;
                    }
                    if (input.xml?.Max && numberValue > input.xml.Max) {
                        return null;
                    }
                    if (input.xml?.Percentage === "TRUE") {
                        return numberValue * 100;
                    }
                    return numberValue;
                }
            } else if (inputType == SharePointInputTypes.datetime.toLowerCase()) {
                return dayjs(value).isValid() ? dayjs(value).toDate() : null;
            } else if (inputType == SharePointInputTypes.Boolean.toLowerCase()) {
                switch (value.toLowerCase().trim()) {
                    case "true":
                        return true;
                    case "false":
                        return false;
                    case "yes":
                        return true;
                    case "no":
                        return false;
                    case "ja":
                        return true;
                    case "nee":
                        return false;
                    default:
                        return null;
                }
            }
        } catch (error) {
            logger(error, "Directory.tsx (validateAndTransformDatasourceValue)");
        }

        return null;
    }
}